var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,_vm._g(_vm._b({tag:"component",staticClass:"exc-link",class:{
    'exc-link--no-decoration': _vm.noDecoration,
    'router-link-active': _vm.$attrs.to && _vm.isActive,
    'exc-link--no-decoration-active': _vm.noDecorationActive
  },on:{"click":_vm.checkCallback}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",null,null,{ isActive: _vm.isActive })],2)}
var staticRenderFns = []

export { render, staticRenderFns }